"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimDispenserControlSafetyMicroOutSerialization = void 0;
class SimDispenserControlSafetyMicroOutSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.SimDispenserControlSafetyMicroOutSerialization = SimDispenserControlSafetyMicroOutSerialization;
